let hasBlockedFirefoxQuickFind = false;

export function blockFirefoxQuickFind() {
  if (hasBlockedFirefoxQuickFind) {
    return;
  }

  const isFirefox = /firefox/i.test(window.navigator.userAgent || "");
  if (!isFirefox) {
    return;
  }

  const shouldIgnoreTarget = (target) => {
    const hasElementApi = typeof Element !== "undefined";
    if (!target || !hasElementApi || !(target instanceof Element)) {
      return false;
    }

    const tagName = target.tagName;
    return (
      target.isContentEditable ||
      tagName === "INPUT" ||
      tagName === "TEXTAREA" ||
      tagName === "SELECT"
    );
  };

  const preventQuickFind = (event) => {
    if (event.defaultPrevented) {
      return;
    }

    const isSlash = event.key === "/";
    const isApostrophe = event.key === "'";
    const isHash = event.key === "#";
    const isOumlautO = event.key === "ö";
    const hasModifier = event.ctrlKey || event.altKey || event.metaKey;

    if ((isSlash || isApostrophe || isHash || isOumlautO) && !hasModifier && !shouldIgnoreTarget(event.target)) {
      event.preventDefault();
    }
  };

  // Firefox can trigger Quick Find on keydown or keypress depending on context.
  window.addEventListener("keydown", preventQuickFind, true);
  window.addEventListener("keypress", preventQuickFind, true);
  hasBlockedFirefoxQuickFind = true;
}